import { useLanguage } from '../i18n';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Globe } from 'lucide-react';

export const LanguageSelector = ({ variant = "ghost" }) => {
  const { language, setLanguage, supportedLanguages } = useLanguage();
  
  const currentLang = supportedLanguages.find(l => l.code === language);
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size="icon" className="relative" data-testid="language-selector">
          <span className="text-lg">{currentLang?.flag || '🌐'}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {supportedLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={language === lang.code ? 'bg-orange-50 dark:bg-orange-900/20' : ''}
            data-testid={`lang-${lang.code}`}
          >
            <span className="mr-2 text-lg">{lang.flag}</span>
            <span className={language === lang.code ? 'font-medium' : ''}>
              {lang.name}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
